import React from 'react'
import hot from './images/as_hot.png'
export const HotAss = () => {
  return (
    <div style = {{width: '100vw',height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFFFFF'}}>
      <img src={hot} style={{width: '53.6%', height: 'auto'}}/>
    </div>
  )
}
